'use strict';

exports.__esModule = true;
exports.default = undefined;

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Table = require('material-ui/Table');

var _Checkbox = require('material-ui/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import Tooltip from 'material-ui/Tooltip';


var EnhancedTableHead = (_temp = _class = function (_Component) {
  _inherits(EnhancedTableHead, _Component);

  function EnhancedTableHead() {
    _classCallCheck(this, EnhancedTableHead);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  } // createSortHandler = property => event => {
  //   this.props.onRequestSort(event, property);
  // };


  EnhancedTableHead.prototype.render = function render() {
    var _props = this.props,
        order = _props.order,
        orderBy = _props.orderBy,
        numSelected = _props.numSelected,
        rowCount = _props.rowCount,
        columnData = _props.columnData;
    return _react2.default.createElement(_Table.TableHead, null, _react2.default.createElement(_Table.TableRow, null, columnData.filter(function (n) {
      return n.hidden !== true;
    }).map(function (column) {
      return _react2.default.createElement(_Table.TableCell, {
        key: column.id,
        numeric: column.numeric,
        padding: column.disablePadding ? 'none' : 'default' // sortDirection={orderBy === column.id ? order : false}

      }, column.label);
    }, this)));
  };

  return EnhancedTableHead;
}(_react.Component), _class.defaultProps = {}, _temp);
exports.default = EnhancedTableHead;
EnhancedTableHead.propTypes = process.env.NODE_ENV !== "production" ? {
  numSelected: _propTypes2.default.number.isRequired,
  // onRequestSort: PropTypes.func.isRequired,
  // onSelectAllClick: PropTypes.func.isRequired,
  order: _propTypes2.default.string.isRequired,
  orderBy: _propTypes2.default.string.isRequired,
  rowCount: _propTypes2.default.number.isRequired,
  columnData: _propTypes2.default.array.isRequired
} : {};
module.exports = exports['default'];